import { ReactNode, HTMLAttributes } from "react";

import './CardBody.scss';

interface CardBodyProps extends HTMLAttributes<HTMLDivElement> {
	variant?: string;
	children: ReactNode;
}

export function CardBody({children, variant, ...rest}: CardBodyProps) {
	return(
		<div className={`card-body ${variant ? variant : ''}`} {...rest}>{children}</div>
	)
}
